export default __webpack_public_path__ + "static/media/aws-kms.6c34b61d.png";